export const Stockhistroydata = [
	{
		id:"1",
		SKU: "PT001",
		Product_Name: "Lenovo IdeaPad 3",
		img: "assets/img/products/stock-img-01.png",
		Initial_Quantity: "6000",
		Added_Quantity: "100",
		Sold_Quantity: "100",
		Defective_Quantity: "100",
		Final_Quantity: "100",
	},
	{
		id:"2",
		SKU: "PT002",
		img: "assets/img/products/stock-img-06.png",
		Product_Name: "Beats Pro",
		Initial_Quantity: "10",
		Added_Quantity: "140",
		Sold_Quantity: "140",
		Defective_Quantity: "140",
		Final_Quantity: "140",
	},
	{
		id:"3",
		SKU: "PT003",
		img: "assets/img/products/stock-img-02.png",
		Product_Name: "Nike Jordan",
		Initial_Quantity: "08",
		Added_Quantity: "300",
		Sold_Quantity: "300",
		Defective_Quantity: "300",
		Final_Quantity: "300",
	},
	{
		id:"4",
		SKU: "PT004",
		img: "assets/img/products/stock-img-03.png",
		Product_Name: "Apple Series 5 Watch",
		Initial_Quantity: "10",
		Added_Quantity: "450",
		Sold_Quantity: "450",
		Defective_Quantity: "450",
		Final_Quantity: "450",
	},
	{
		id:"5",
		SKU: "PT005",
		img: "assets/img/products/stock-img-04.png",
		Product_Name: "Amazon Echo Dot",
		Initial_Quantity: "05",
		Added_Quantity: "320",
		Sold_Quantity: "320",
		Defective_Quantity: "320",
		Final_Quantity: "320",
	},
	{
		id:"6",
		SKU: "PT006",
		img: "assets/img/products/stock-img-05.png",
		Product_Name: "Sanford Chair Sofa",
		Initial_Quantity: "07",
		Added_Quantity: "650",
		Sold_Quantity: "650",
		Defective_Quantity: "650",
		Final_Quantity: "650",
	},
	{
		id:"7",
		SKU: "PT007",
		img: "assets/img/products/expire-product-01.png",
		Product_Name: "Red Premium Satchel",
		Initial_Quantity: "15",
		Added_Quantity: "700",
		Sold_Quantity: "700",
		Defective_Quantity: "700",
		Final_Quantity: "700",
	},
	{
		id:"8",
		SKU: "PT008",
		img: "assets/img/products/expire-product-02.png",
		Product_Name: "Iphone 14 Pro",
		Initial_Quantity: "12",
		Added_Quantity: "630",
		Sold_Quantity: "630",
		Defective_Quantity: "630",
		Final_Quantity: "630",
	},
	{
		id:"9",
		SKU: "PT009",
		img: "assets/img/products/expire-product-03.png",
		Product_Name: "Gaming Chair",
		Initial_Quantity: "10",
		Added_Quantity: "410",
		Sold_Quantity: "410",
		Defective_Quantity: "410",
		Final_Quantity: "410",
	},
	{
		id:"10",
		SKU: "PT010",
		img: "assets/img/products/expire-product-04.png",
		Product_Name: "Borealis Backpack",
		Initial_Quantity: "20",
		Added_Quantity: "550",
		Sold_Quantity: "550",
		Defective_Quantity: "550",
		Final_Quantity: "550",
	},
];
